import React from 'react';
import styles from '../Chart.module.css';
import { useSelector } from 'react-redux';
import { SqiTooltipIcon } from '../../../../components/icons/Icons';
import { getUnitByVitalType } from '../../../../utils/unitUtils';

const PerinTooltip = ({ active, payload, label, vitals, systemRules }) => {
    const averageGrouped = useSelector((state) => state.patientDetailFilter.averageGrouped);
    const userUnitPreference = useSelector((state) => state.userInfo.unitType);


    const convertThresholdValue = (value, vitalType) => {
      if (value === 0 || value === undefined || value === null) return value;
      
      switch(vitalType) {
        case 'temperature':
          return userUnitPreference === 'Imperial' ? 
            parseFloat(((value * 9/5) + 32).toFixed(1)) : 
            parseFloat(value.toFixed(1));
        case 'weight':
          return userUnitPreference === 'Imperial' ? 
            Math.round((value * 2.20462)) : 
            Math.round(value);
        default:
          return parseFloat(value.toFixed(1));
      }
    };

    const formatValue = (value, vitalType) => {
      if (value === 0 || value === undefined || value === null) return value;
      
      switch(vitalType) {
        case 'temperature':
          return parseFloat(value.toFixed(1));
        case 'respiratoryRate':
          let defaultRespValues = systemRules.find((item)=>item.modalityId === vitals?.modalityId && item.type === 'modality');
          if (defaultRespValues && value > defaultRespValues.targetUpperValue) {
            return `> 30`;
          }
          return parseFloat(value.toFixed(1));
        default:
          return Math.round(value);
      }
    };


    const filteredPayload = payload.filter(
      (entry) => !entry.dataKey.includes('-range') && !entry.dataKey.includes('alertY')
    );

    const barData = payload.find(p => p.dataKey === 'alertY');

    if (filteredPayload.length === 0 && !barData) {
        return null;
    }
    if (active && payload && filteredPayload.length) {
      const dataKey = filteredPayload[0].dataKey.split('.');
      const deviceName = dataKey[0];
      const vitalType = dataKey[1];
      const data = filteredPayload[0].payload[deviceName] ?? filteredPayload[0].payload;
      const unit = getUnitByVitalType(vitalType, userUnitPreference);
      

      // Convert threshold values based on unit preferences
      const targetValue = convertThresholdValue(vitals?.targetValue, vitalType);
      const upperLimit = convertThresholdValue(vitals?.upperLimit, vitalType);
      const lowerLimit = convertThresholdValue(vitals?.lowerLimit, vitalType);


      return (
        <div className={styles.PerinTooltip}>
          { data[`${vitalType}_sqi`] === 'acceptable' &&
              <div style={{display:"flex", alignItems:"center", gap:"5px", fontSize:"10px", fontWeight:"700"}}>
                <SqiTooltipIcon />
                LOW SIGNAL QUALITY
              </div>
          }
          { data[`${vitalType}_adhoc`] === true && !averageGrouped &&
              <div style={{display:"flex", alignItems:"center", gap:"5px", fontSize:"10px", fontWeight:"700", color:"#F5C10D"}}>
            
               Adhoc Recording
              </div>
          }
          <p>
            {averageGrouped && 
              <span style={{fontSize:"16px"}}>{"Avg: "}</span>
            }
            <span style={{fontSize:"20px"}}>{`${data[vitalType] !== undefined ? `${formatValue(data[vitalType], vitalType)}${unit}` : 'N/A'}`}</span>
          </p>
          <p style={{ fontSize:"16px"}}>{`${deviceName}: ${data["date"] ?? 'Date: N/A'}`}</p>
          {data.posture && vitalType !== 'steps' && (
            <p style={{ fontSize:"16px"}}>{`Posture: ${data.posture}`}</p>
          )}
          {data.activityLevel && vitalType !== 'steps' && (
            <p style={{ fontSize:"16px"}}>{`Activity Level: ${data.activityLevel}`}</p>
          )}
          {averageGrouped && data[`${vitalType}-range`] &&
            <>
              <p style={{ fontSize:"12px"}}>{`Max: ${formatValue(data[`${vitalType}-range`]?.max, vitalType)}${unit}`}</p>
              <p style={{ fontSize:"12px"}}>{`Min: ${formatValue(data[`${vitalType}-range`]?.min, vitalType)}${unit}`}</p>
            </>
          }
          {(targetValue !== 0 || upperLimit !== 0 || lowerLimit  !== 0) &&
            <hr style={{margin: "0"}}></hr>
          }
          {targetValue !== 0 &&
          <p style={{fontSize:"12px", fontWeight:"700" }}>{`Target Value: ${targetValue}${unit}`}</p>
          }
          {upperLimit !== 0 &&
          <p style={{fontSize:"12px",fontWeight:"700" }}>{`Upper Limit: ${upperLimit}${unit}`}</p>
          }
          {lowerLimit !== 0 &&
          <p style={{fontSize:"12px",fontWeight:"700" }}>{`Lower Limit: ${lowerLimit}${unit}`}</p>
          }
          {barData &&
            <>
              <hr style={{margin: "0"}}></hr>
              <p style={{fontSize:"12px",fontWeight:"700" }}>{`${barData.payload.alert?.alert_hover_display}`}</p>
            </>
          }
        </div>
      );
    }

    else if (barData) {
      return (
        <div className={styles.PerinTooltip}>
          <p style={{ fontSize: "12px", fontWeight: "700" }}>{`${barData.payload.date}`}</p>
          <p style={{ fontSize: "12px", fontWeight: "700" }}>{`${barData.payload.alert?.alert_hover_display}`}</p>
        </div>
      );
    }

    return null;
};

export default PerinTooltip;
